module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('p', {
    staticClass: "tips"
  }, [_c('mu-icon', {
    staticClass: "loading-icon",
    attrs: {
      "value": "cached"
    }
  }), _vm._v("正在跳转中...\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dba6d7f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uniteLogin/ldyBridge.vue
// module id = 1600
// module chunks = 18